module.exports = "<app-route-edit-photos route=$ctrl.route on-change=$ctrl.setDirty() on-valid-change=$ctrl.setValid(valid)></app-route-edit-photos> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/route/edit/photos/template.html
// module id = 476
// module chunks = 0